import React, { useState } from "react";
import AuthLayout from "./AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { usePostResetPasswordMutation } from "../../service/auth";
import { showError, showToast } from "../../constants/toasts";
import Loader from "../../constants/Loader";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [resetPassword] = usePostResetPasswordMutation();
  const { state } = useLocation();

  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => {
    setShowPassword1((prev) => !prev);
  };
  const handleMouseDownPassword1 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .label("new Password")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
          "Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 special character."
        )
        .required("New password is required."),

      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Passwords must match.")
        .required("Confirm password is required."),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        email: state?.email,
        password: formik.values.confirmPassword,
      };

      try {
        setLoading(true);
        const response = await resetPassword(body).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          navigate("/");
          showToast("Password changed successfully");
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
      }
      formik.setSubmitting(false);
    },
  });

  return (
    <AuthLayout>
      <Loader isLoad={loading} />
      <div className="authBox">
        <h2>Reset Password</h2>
        <p>Choose strong password for your account</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label>New Password</label>
            <TextField
              placeholder="Enter New Password"
              fullWidth
              hiddenLabel
              id="newPassword"
              name="newPassword"
              type={showPassword ? "text" : "password"}
              value={formik.values.newPassword}
              onChange={(val) => {
                if (val.target.value === " " || val.target.value === ".") {
                } else {
                  formik.handleChange(val);
                }
              }}
              className="text_field"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.newPassword && formik.errors.newPassword
              }
            />
          </div>
          <div className="control_group">
            <label>Confirm Password</label>
            <TextField
              placeholder="Enter Confirm Password"
              fullWidth
              hiddenLabel
              id="confirmPassword"
              name="confirmPassword"
              type={showPassword1 ? "text" : "password"}
              value={formik.values.confirmPassword}
              onChange={(val) => {
                if (val.target.value === " " || val.target.value === ".") {
                } else {
                  formik.handleChange(val);
                }
              }}
              className="text_field"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showPassword1 ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword1}
                      onMouseDown={handleMouseDownPassword1}
                      edge="end"
                    >
                      {showPassword1 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
            />
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" type="submit">
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
